import moment from 'moment';

export const fakeUser = {
    id: 30,
    firstName: 'John',
    lastName: 'Smith',
    dateOfBirth: moment("1982-10-12", "YYYY-MM-DD"),
    medicareNumber: 123456, 
}

export const fakeLabResults = [
    {
        type: 'Covid19',
        result: false,
        date: moment("2020-03-25T12:00:00Z", moment.ISO_8601),

    },
    {
        type: 'Covid19',
        result: true,
        date: moment("2020-03-22T11:00:00Z", moment.ISO_8601),
    }
]

export const fakeResponse = {
    success:true,
    message:"",
    error:{},
    data:{
        patientResults:{
            firstName:"Jane",
            lastName:"Doe",
            dateOfBirth:"1938-11-20",
            hcn:"123456789",
            results:[
                {
                    result: "Positive",
                    resultType: "COVID-19",
                    mnemonic: "XMB880-8",
                    resultDate: "2020-04-06 00:00:04",
                    collectionSite: "ACCESS Transcona",
                    collectionDate: null,
                    resultStatus: "F"
                },
                {
                    resultStatus: "F",
                    resultCode: "CANCELLED",
                    mnemonic: "PCRNCOV",
                    collectionDate:"2020-09-12T00:00:00Z",
                    resultDate:"2020-09-28T00:12:00Z",
                    result:"Result Cancelled",
                    resultType: "covid-19",
                    collectionSite: "Winnipeg, MB"
                },
                {
                    resultStatus: "F",
                    resultCode: "NORESULT",
                    mnemonic: "PCRNCOV",
                    collectionDate:"2020-02-12T00:00:00Z",
                    resultDate:"2020-03-30T00:12:00Z",
                    result:"Awaiting Result",
                    resultType: "covid-19",
                    collectionSite: "Winnipeg, MB"
                }, 
                {
                    resultStatus: "F",
                    mnemonic: "PCRNCOV",
                    resultCode: "NEGATIVE",
                    collectionDate:"2020-03-18T00:00:00Z",
                    resultDate:"2020-03-18T00:12:00Z",
                    result:"Negative",
                    resultType: "covid-19",
                    collectionSite: "Winnipeg, MB"
                },
                {
                    resultStatus: "F",
                    resultCode: "INVALID",
                    mnemonic: "PCRNCOV",
                    collectionDate:"2020-09-12T00:00:00Z",
                    resultDate:"2020-09-27T00:12:00Z",
                    result:"Result Invalid",
                    resultType: "covid-19",
                    collectionSite: "Winnipeg, MB"
                },
                {
                    resultStatus: "F",
                    resultCode: "EQUIVOCAL",
                    mnemonic: "PCRNCOV",
                    collectionDate:"2020-02-05T00:00:00Z",
                    resultDate:"2020-04-03T00:12:00Z",
                    result:"Equivocal",
                    resultType: "covid-19",
                    collectionSite: "Winnipeg, MB"
                }
            ]
        }
    },
    responseId:"4ea19b20-1d04-4075-9030-150eac62cb3a",
    responseTimestamp:"2020-03-27T15:12:49.893969344Z"
}

export const fakeImmunizationResult = {
    success: true,
    message: "",
    error: {},
    data: {
        patientImmunization: {
            firstName:"Jane",
            lastName:"Doe",
            dateOfBirth:"1938-11-20",
            hcn:"123456789",
            immunizations: [
                {
                    "immunizationName": "Pfizer-BioNTech COVID-19 mRNA",
                    "immunizationDate": "2021-02-20",
                    "locationName": "Golden Links Lodge (Winnipeg)"
                },
                {
                    "immunizationName": "Pfizer-BioNTech COVID-19 mRNA",
                    "immunizationDate": "2021-04-28",
                    "locationName": "COVID19 Immunization Site"
                },
                {
                    "immunizationName": "Moderna COVID-19 mRNA",
                    "immunizationDate": "2021-01-30",
                    "locationName": "University of Manitoba Bannatyne Campus"
                }
            ]
        },
    },
    responseId:"4ea19b20-1d04-4075-9030-150eac62cb3a",
    responseTimestamp:"2020-03-27T15:12:49.893969344Z"
}